import type { FetchThirdPartyConnectorsResponse } from '@jira/issue__third-party-connected-data-sources/src/services/fetch-third-party-connectors/types.tsx';
import { createResource } from '@atlassian/react-resource-router';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-issue-view-third-party-connected-data-source", jiraSpaEntry: "async-resource-issue-view-third-party-connected-data-source" */ '@jira/issue__third-party-connected-data-sources/src/services/fetch-third-party-connectors/index.tsx'
	);

export const thirdPartyConnectedDataSourceResource =
	createResource<FetchThirdPartyConnectorsResponse>({
		type: 'ISSUE_VIEW_THIRD_PARTY_CONNECTORS',
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader,
		maxAge: Infinity,
		isBrowserOnly: true,
	});
